module.exports = __webpack_public_path__ + "static/media/eyebag.ccd20988.svg";